import { element } from './util';

/**
 * Returns whether clicking this target should open a rendered slide link.
 *
 * The slide renderer adds `data-slide-link-navigation-enabled` only when link clicks
 * should open URLs. Links inside that marked container should not be sent to any input
 * handling state machines.
 */
export const isSlidesRenderedLink = (target: EventTarget | null): boolean => {
  return !!element(target)?.closest(
    '[data-slide-link-navigation-enabled="true"] a[href]',
  );
};
